import { useTranslation } from 'react-i18next';

interface InvitingWorkspaceLineProps {
  workspaceName: string | null;
}

export function InvitingWorkspaceLine({ workspaceName }: InvitingWorkspaceLineProps) {
  const { t } = useTranslation('auth');
  if (workspaceName === null || workspaceName.trim() === '') {
    return null;
  }
  return (
    <p className="text-xs font-bold text-zooprimary tracking-wider uppercase mb-2">
      {t('acceptInvitation.invitedBy', { workspace: workspaceName })}
    </p>
  );
}
